import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchUpdatedEmpList = createAsyncThunk("fetchUpdatedEmpList", async () => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`employee/list/modified`, config);
	return response.data.data;
});

const UpdatedEmpListSlice = createSlice({
	name: "UpdatedEmpListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchUpdatedEmpList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchUpdatedEmpList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchUpdatedEmpList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default UpdatedEmpListSlice.reducer;
